import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import ActivityForm from '../Form';
import { createActivity } from '@resources/Activity/actions';
import { useIntl } from 'react-intl';
import { fetchModulesBySubmoduleCode } from '@resources/Module/actions';

const Create = (props) => {
	const { createActivity, visible, onCancel, module } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createActivity(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.activity.create',
						defaultMessage:
							'A new Activity has been successfully created',
					})
				);
				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.activity',
					defaultMessage: 'Create Activity',
				})}
			</Title>
			<ActivityForm onSubmit={handleSubmit} {...props} module={module} />
		</Modal>
	);
};

const mapStateToProps = ({
	activities,
	modules,
	event,
	facility,
	ministry,
	cellGroup,
	organization,
}) => {
	return {
		activities,
		ministry,
		facility,
		modules,
		event,
		cellGroup,
		organization,
	};
};

export default connect(mapStateToProps, {
	createActivity,
	fetchModulesBySubmoduleCode,
})(Create);
